import { useDefaultAppContexts } from 'hb-react/frontoffice/contexts/withDefaultAppContexts';
import { usePageMenuName, PAGES } from 'hb-react/shared/hooks/usePageMenuName';

const useTopicsMenuName = () => {
  const { currentNetwork } = useDefaultAppContexts();
  const defaultName = s__('Topics|Topics');
  const menuName = usePageMenuName(PAGES.TOPICS, defaultName);

  if (menuName) {
    return menuName;
  }

  // Try to get the name from the features configuration.
  if (currentNetwork?.features?.topics?.config?.menu_name) {
    return currentNetwork.features.topics.config.menu_name;
  }

  return defaultName;
};

export default useTopicsMenuName;
